//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as mailTrashAction from '../action/mailTrashAction';
import * as notificationAction from '../action/notificationAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as helpAction from '../action/helpAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

//Menu
import MenuMailbox from './MenuMailbox';
//Part
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {

  constructor(props) {
    super(props);
  	this.state = {
      mailTrashEditAnchor: null,
      mailTrashEditPic: null,
      mailTrashEditName: null,
      mailTrashRestorePic: null,
      mailTrashDelPic: null,
  	}
  }

  componentDidMount() {
    document.title = 'メールボックス - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.props.mailTrash.datetime) {
      this.props.mailTrashListGet(1);
      window.scrollTo(0, 0);
    }
  }

  _onPaging(page) {
    this.props.mailTrashListGet(page);
    window.scrollTo(0, 0);
  }

	_renderList(item, index, arr) {
		return (
      <div
        key={index}
        style={{
          padding:'5px',
          borderBottom: (arr.length - 1 > index) ? 'solid 1px #DDD': '',
          backgroundColor: '#FFF'
        }}
      >
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
              }}
            >
              <div
                onClick={ () => this.props.history.push({pathname: '/partner/' + item.pic, referrer: '/mailbox/trash/'}) }
                style={{padding:'5px',cursor:'pointer'}}
              >
                <div
                  style={{padding:'5px'}}
                >
                  <div>
                    <PartUserName
                      data={{
                        name: item.userdata_name,
                        sex: item.userdata_sex,
                        size: '1.2em',
                      }}
                    />&nbsp;
                    <span style={{color:'#333'}}>{item.userdata_age}才 {item.userdata_region}</span>
                  </div>

                  <div>{item.mail_cnt}件</div>
                </div>
              </div>

              <div style={{marginLeft: 'auto'}}>
                <IconButton
                  onClick={ (event) => this.setState({mailTrashEditPic:item.pic,　mailTrashEditName:item.userdata_name, mailTrashEditAnchor:event.currentTarget}) }
                >
                  <MoreVertSharpIcon />
                </IconButton>
              </div>

      			</div>

      </div>
		);
	};


	render() {
		return (
      <div>
        <div style={{maxWidth:'480px', margin:'auto'}}>
          <MenuMailbox />
        </div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
              margin: '10px',
            }}
          >
            <div></div>
            <div>
              <span style={{color:'#666'}}>ページ{this.props.mailTrash.page}</span>

              <IconButton
                onClick={ () => this.props.mailTrashListGet(1) }
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </div>
          {
            (this.props.mailTrash.datetime) && (
              (this.props.mailTrash.list.length > 0) ? (
                <div>

                  <Box boxShadow={2} style={{background:'#FFF'}}>
                    {
                      this.props.mailTrash.list.map(
                      	(value, index, arr) => this._renderList(value, index, arr)
                    	)
            				}
                  </Box>

                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.mailTrash.page}
                      isNext={this.props.mailTrash.isListNext}
                      onClick={ (e) => this._onPaging(e) }
                    />
                  </div>

                </div>
              ) : (
                <h2 align='center' style={{padding:'30px 0px'}}>
                  <span className='i-b'>ゴミ箱に入れたメールは</span>
                  <span className='i-b'>メールが見つかりませんでした</span>
                </h2>
              )
            )
          }
      	</div>

        <Menu
          anchorEl={this.state.mailTrashEditAnchor}
          keepMounted
          open={(this.state.mailTrashEditPic)? true: false}
          onClick={ () => this.setState({mailTrashEditPic: null}) }
        >
          <MenuItem
            onClick={ () => {
              this.setState({mailTrashRestorePic:this.state.mailTrashEditPic});
            }}
          >
            <div>
              ゴミ箱からメールボックスに戻す
            </div>
          </MenuItem>
          <MenuItem
            onClick={ () => {
              this.setState({mailTrashDelPic:this.state.mailTrashEditPic});
            }}
          >
            <div>
              ゴミ箱からも完全に削除する
            </div>
          </MenuItem>
        </Menu>

        <DialogConfirm
          open={ (this.state.mailTrashRestorePic) ? true : false }
          title={'メールの復元'}
          content={(
            <div>
              <div>
                {this.state.mailTrashEditName}さんとのメールをメールボックスに戻しますか？
              </div>
            </div>
          )}
          apply={ () => {
            this.props.mailTrashItemRestore(this.state.mailTrashRestorePic);
            this.setState({mailTrashRestorePic: null});
          }}
          close={ () => this.setState({mailTrashRestorePic: null}) }
        />
        <DialogConfirm
          open={ (this.state.mailTrashDelPic) ? true : false }
          title={'メールの削除'}
          content={(
            <div>
              <div>
                {this.state.mailTrashEditName}さんとのメールをゴミ箱から削除しますか？
              </div>
              <div style={{fontSize:'0.9em',color:'#666'}}>
                ※ゴミ箱から削除すると復旧はできません。
              </div>
            </div>
          )}
          apply={ () => {
            this.props.mailTrashItemDel(this.state.mailTrashDelPic);
            this.setState({mailTrashDelPic: null});
          }}
          close={ () => this.setState({mailTrashDelPic: null}) }
        />
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
    mailTrash: state.mailTrash,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...mailTrashAction,
    ...notificationAction,
    ...partnerOperationAction,
    ...helpAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
